module.exports = __webpack_public_path__ + "static/media/overpass-extralight.7a42efd1.ttf";